import { backendApi } from '../../config'

export type PartnerInvitePreview = {
  email: string
  eventName: string
  inviterName: string
  isExistingUser: boolean
  status: string
}

export const getPartnerInviteService = async (token: string) => {
  const { data } = await backendApi.get<PartnerInvitePreview>(
    `/api/creators/partners/invites/${token}`
  )
  return data
}
